import * as React from "react";
import { UitkCheckbox } from "uitk-react-switch";
import { UitkExpandoLink, UitkExpandoLinkTypeSize } from "uitk-react-expando";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { ViewMedium, Viewport, ViewSmall } from "bernie-view";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { WizardHotelFilterType } from "./WizardHotelFilterType";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

const WizardHotelFilterList = [
  WizardHotelFilterType.businessFriendly,
  WizardHotelFilterType.freeCancellation,
  WizardHotelFilterType.familyFriendly,
  WizardHotelFilterType.breakfastIncluded,
];
const WizardHotelFilterListMobile = [
  WizardHotelFilterType.businessFriendly,
  WizardHotelFilterType.familyFriendly,
  WizardHotelFilterType.freeCancellation,
  WizardHotelFilterType.breakfastIncluded,
];

export const WizardHotelPWAFilter = ({
  checkboxFilterChecks,
  changeFormProperties,
  advancedOptionsFilterVisible,
}: {
  checkboxFilterChecks: object;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  advancedOptionsFilterVisible: boolean;
}) => {
  const { formatText } = useLocalization();
  const title = formatText(locKeys.filterAdvancedOptionsLink);

  return (
    <UitkLayoutFlex space="three">
      <UitkExpandoLink
        type={UitkExpandoLinkTypeSize.TYPE_300}
        expandoTitle={title}
        isVisible={advancedOptionsFilterVisible}
      >
        <Viewport>
          <ViewSmall>
            <>
              {WizardHotelFilterListMobile.map(({ id, key, filterTypeKey, name, value }) => (
                <UitkCheckbox
                  id={id}
                  name={name}
                  label={formatText(filterTypeKey)}
                  checked={checkboxFilterChecks[key]}
                  onChange={changeFormProperties}
                  value={value}
                  key={key}
                />
              ))}
            </>
          </ViewSmall>
          <ViewMedium>
            <UitkLayoutGrid columns={2} className="filterCheckboxesContainer">
              {WizardHotelFilterList.map(({ id, key, filterTypeKey, name, value }) => (
                <UitkLayoutGridItem key={key}>
                  <UitkCheckbox
                    id={id}
                    name={name}
                    label={formatText(filterTypeKey)}
                    checked={checkboxFilterChecks[key]}
                    onChange={changeFormProperties}
                    value={value}
                  />
                </UitkLayoutGridItem>
              ))}
            </UitkLayoutGrid>
          </ViewMedium>
        </Viewport>
      </UitkExpandoLink>
    </UitkLayoutFlex>
  );
};
